import { colors } from '@/constants';
import { CarTypesEnum } from '../car-type';

export const gradientColors = carType =>
    carType === CarTypesEnum.CERTIFIED
        ? colors['primary-25']
        : carType === CarTypesEnum.LITE
        ? colors['lite-25']
        : colors['dealer-25'];
